import { Link } from "react-router-dom";
import { CheckCircle2, BellOff, AlertCircle, Bell } from "lucide-react";
import { Layout } from "@/components/Layout";

const VARIANTS = {
  confirmed: {
    icon: CheckCircle2,
    color: "#1E63C4",
    title: "You're subscribed!",
    body: "Thanks for confirming. We'll email you whenever there's news in the categories you chose.",
    testid: "subscribe-confirmed",
  },
  unsubscribed: {
    icon: BellOff,
    color: "#555555",
    title: "You've been unsubscribed",
    body: "You won't receive any more update emails. You can re-subscribe anytime from the Notify page.",
    testid: "subscribe-unsubscribed",
  },
  error: {
    icon: AlertCircle,
    color: "#E11D2A",
    title: "That link has expired",
    body: "This confirmation link is no longer valid. Please head back to the Notify page and sign up again.",
    testid: "subscribe-error",
  },
};

export default function SubscribeResult({ variant = "confirmed" }) {
  const v = VARIANTS[variant] || VARIANTS.confirmed;
  const Icon = v.icon;
  return (
    <Layout>
      <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid={v.testid}>
        <Icon className="h-16 w-16 mx-auto mb-5" style={{ color: v.color }} />
        <h1 className="font-heading font-extrabold text-3xl text-[#111111] mb-3">{v.title}</h1>
        <p className="text-[#555555] mb-8">{v.body}</p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-1.5 bg-[#1E63C4] text-white rounded-md px-5 py-2.5 font-semibold hover:bg-[#174e9c]">
            Back to home
          </Link>
          <Link to="/notify" className="inline-flex items-center gap-1.5 border border-[#E5E7EB] rounded-md px-5 py-2.5 font-semibold text-[#1E63C4] hover:border-[#1E63C4]">
            <Bell className="h-4 w-4" /> Manage updates
          </Link>
        </div>
      </div>
    </Layout>
  );
}
